import React, { useState } from "react";
import * as styles from "./faqSection.module.css";
import { Box, Grid } from "@mui/material";
import FAQ from "../faq/faq";

export default ({ node }) => {
  const { headText, faqItem } = node;
  return (
    <Box>
      <Box>
        <Grid container>
          <Grid item xs={12}>
            <Box mb={2}>
              <h3 className={styles.faqHeadText}>
                <strong>{headText}</strong>
              </h3>
            </Box>
            <Box>
              {faqItem.map((item, index) => {
                return <FAQ node={item} index={index}/>;
              })}
            </Box>
          </Grid>
        </Grid>
      </Box>
    </Box>
  );
};
